import { Trash } from "lucide-react";

import CustomButton from "@/components/desktop/button/CustomButton";
import CustomInputText from "@/components/desktop/form/input/input-text/CustomInputText";
import CustomInputPhone from "@/components/desktop/form/input/input-phone/CustomInputPhone";

import styles from "./MemberForm.module.scss";

const MemberForm = ({ member, index, onUpdate, onRemove, error }) => {
	return (
		<div className={styles.row}>
			<div className={styles.cell}>
				<CustomInputText
					label=""
					name={`member_name_${index}`}
					value={member.name}
					onChange={(value) => onUpdate(index, { name: value })}
					placeholder="Nombre"
					required
					size="sm"
					error={error}
				/>
			</div>

			<div className={styles.cell}>
				<CustomInputText
					label=""
					name={`member_email_${index}`}
					value={member.email}
					onChange={(value) => onUpdate(index, { email: value })}
					placeholder="Correo"
					required
					size="sm"
					error={error}
				/>
			</div>

			<div className={styles.cellCompact}>
				<CustomInputPhone
					label=""
					name={`member_phone_${index}`}
					value={member.phone}
					onChange={(value) => onUpdate(index, { phone: value })}
					placeholder="Teléfono"
					size="sm"
				/>
			</div>

			<div className={styles.cellActions}>
				<CustomButton size="sm" variant="danger" onClick={() => onRemove(index)}>
					<Trash size={14} />
				</CustomButton>
			</div>
		</div>
	);
};

export default MemberForm;
